import 'isomorphic-fetch';
import { buildHeadersFromRequest } from '../utils/requestHelper';
import configUtil from '../utils/config';
import { TRACK_SESSION_STARTED } from '../actions/tracking/types';

const SESSION_ENDPOINT = '/orderapp/v1/session';
const EVENTS_ENDPOINT = '/orderapp/v1/events';
const TRACK_EVENT_PREFIX = 'TRACK_';

// only pay attention to action types beginning with TRACK_
export function isAnalyticsAction(type) {
  const actionTypeRegex = new RegExp(`^${TRACK_EVENT_PREFIX}`);
  return actionTypeRegex.test(type);
}

export function validateAnalyticsData(event) {
  // ensure events have all requisite properties
  const requiredKeys = ['name', 'time', 'properties'];

  const payloadKeys = Object.keys(event);
  const missingKeys = requiredKeys.filter((key) => payloadKeys.indexOf(key) === -1);

  if (missingKeys.length) {
    // eslint-disable-next-line no-console
    console.warn(`Expected a value for event['${missingKeys[0]}'] but received undefined`);
    return false;
  }

  return true;
}

export function buildAnalyticsEvent({ payload }) {
  return Object.assign(
    {},
    {
      ...payload,
      time: Math.round(Date.now() / 1000),
    },
  );
}

export function catchFetchError(error) {
  const isServerFetchError = error.name === 'FetchError';

  if (!isServerFetchError) {
    throw error;
  }
}

export function sendEvent(event, options, isSessionStartedEvent = false) {
  const apiHost = configUtil.orderappApiHost;

  // session started has it's own endpoint so route that event rhere
  const url = isSessionStartedEvent
    ? `${apiHost}${SESSION_ENDPOINT}`
    : `${apiHost}${EVENTS_ENDPOINT}`;

  const baseOptions = Object.assign({}, options, {
    body: JSON.stringify({ events: [event] }),
    method: 'POST',
  });

  return fetch(url, baseOptions).catch(catchFetchError);
}

const track = (store) => (next) => (action) => {
  const shouldHandleAction = isAnalyticsAction(action.type);
  if (!shouldHandleAction) {
    return next(action);
  }

  const event = buildAnalyticsEvent(action);

  if (!validateAnalyticsData(event)) {
    return next(action);
  }

  const { request, config } = store.getState();

  const options = {
    headers: {
      'content-type': 'application/json',
      ...buildHeadersFromRequest({ request, config }),
    },
    // Prevent slow session calls hanging the page. We may lose some analytics
    // data, but don't return an error for the user.
    timeout: 2000,
  };

  const isSessionStartedEvent = action.type === TRACK_SESSION_STARTED;
  return (
    sendEvent(event, options, isSessionStartedEvent)
      // this action won't do anything, it's purely for devtools tracing
      .then(() =>
        next({
          type: action.type,
          payload: event,
        }),
      )
  );
};

export default track;
